/**
 * 复制功能
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { message, } from "antd";
import {isEmpty,trim} from '@utils/utils';
import PropTypes from "prop-types";
import "./Index.less";
import {CopyFilled} from "@ant-design/icons";
import Lang from "../Lang/Lang";

class CopyInput extends React.Component{
    static propTypes ={
        optionId:PropTypes.string.isRequired,
        value:PropTypes.string.isRequired,
    }
    static defaultProps = {
        optionId:'',
        value:'',

    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        }
    }
    /**
     * 复制动作
     ***/
    handleCopy(inputId=''){
        let agent = document.getElementById(inputId);
            agent.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
        message.success(Lang({id:"FuZhiChengGong",default:"复制成功"}));
    }

    componentDidMount() {
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { value,optionId,children } =this.props;
        return (<span onClick={()=>this.handleCopy(optionId)}>
            <input className={'input-hidden'} id={optionId} value={value} readOnly />
            {children||<i className="ri-file-copy-2-line black33 font_16 cursor-p"  />}
            {/*<i className="ri-file-copy-2-line black33 font_16 cursor-p" onClick={()=>this.handleCopy(optionId)} />*/}
       </span>)
    }
}

export default CopyInput;
